export default "__VITE_ASSET__bAQ7H43s__"